var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlucose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 52,
    viewBox: "0 0 58 52",
    width: 58,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-6.975 -10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h71.25v71.25h-71.25z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#14328c",
    strokeWidth: 2.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.8961375 52.0354425c1.9551 1.323825 2.466675 3.98145 1.1457 5.93655-1.32525 1.9551-3.98145 2.46525-5.93655 1.14285-1.9551-1.323825-2.4681-3.98145-1.1457-5.93655 1.32525-1.953675 3.98145-2.466675 5.93655-1.14285z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.8711375 12.1354425c1.9551 1.323825 2.466675 3.98145 1.1457 5.93655-1.32525 1.9551-3.98145 2.46525-5.93655 1.14285-1.9551-1.323825-2.4681-3.98145-1.1457-5.93655 1.326675-1.953675 3.98145-2.466675 5.93655-1.14285z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.30549 28.4234775c3.586725 2.426775 4.52295 7.29885 2.0976 10.882725s-7.29885 4.52295-10.88415 2.096175c-3.583875-2.426775-4.521525-7.29885-2.096175-10.882725 2.426775-3.583875 7.29885-4.52295 10.882725-2.096175z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.8817775 28.17795c2.934075 1.98645 3.70215 5.972175 1.7157 8.904825-1.9836 2.93265-5.97075 3.6993-8.904825 1.714275-2.93265-1.985025-3.700725-5.97075-1.714275-8.9034s5.97075-3.700725 8.9034-1.7157z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.8317775 15.35295c2.934075 1.98645 3.70215 5.972175 1.7157 8.904825-1.9836 2.93265-5.97075 3.6993-8.904825 1.714275-2.93265-1.985025-3.700725-5.97075-1.714275-8.9034s5.97075-3.700725 8.9034-1.7157z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.5567775 36.72795c2.934075 1.98645 3.70215 5.972175 1.7157 8.904825-1.9836 2.93265-5.97075 3.6993-8.904825 1.714275-2.93265-1.985025-3.700725-5.97075-1.714275-8.9034s5.97075-3.700725 8.9034-1.7157z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.63053 30.241635-5.03595-4.626975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.16633 51.03837 2.669025-8.7267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.7386 34.364303 6.95115-.765225"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlucose);
export default __webpack_public_path__ + "static/media/glucose.f32932592e5b419702b528c72c614a1d.svg";
export { ForwardRef as ReactComponent };